export const FORMATION_LABELS = {
  initiale: "CAP AEPE — Initiale",
  alternance: "CAP AEPE — Alternance",
  continue: "CAP AEPE — Continue",
  vae: "VAE Petite Enfance",
};

export const SITUATION_LABELS = {
  salarie: "Salarié(e)",
  demandeur: "Demandeur d'emploi",
  etudiant: "Étudiant(e)",
  reconversion: "Reconversion",
  autre: "Autre",
};

export function formatDate(iso) {
  if (!iso) return "—";
  try {
    return new Date(iso).toLocaleString("fr-FR", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    });
  } catch {
    return iso;
  }
}
